import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClientHeader } from "./ClientShell";
import { capi, useNoindex, frDate } from "./clientApi";

export default function ClientDashboard() {
  useNoindex();
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      const meRes = await capi("/me").catch(() => null);
      if (!meRes || meRes.status === 401) { navigate("/espace-client/connexion"); return; }
      const meData = await meRes.json();
      const cRes = await capi("/campaigns").catch(() => null);
      const cData = cRes && cRes.ok ? await cRes.json() : [];
      if (!alive) return;
      setMe(meData); setCampaigns(cData); setLoading(false);
    })();
    return () => { alive = false; };
  }, [navigate]);

  const logout = async () => { await capi("/auth/logout", { method: "POST" }).catch(() => {}); navigate("/espace-client/connexion"); };

  return (
    <div className="cp-root" data-testid="cp-dashboard">
      <ClientHeader me={me} onLogout={logout} hasNews />
      <div className="cp-page">
        <h1 className="cp-hello" data-testid="cp-hello">Bonjour {me?.first_name || ""}</h1>
        <p className="cp-hello-sub" data-testid="cp-org">{me?.organization_name || "Vos campagnes"}</p>

        {loading ? (
          <p className="cp-muted" data-testid="cp-dash-loading">Chargement…</p>
        ) : campaigns.length === 0 ? (
          <div className="cp-panel" data-testid="cp-no-campaigns">Aucune campagne pour le moment.</div>
        ) : (
          <div data-testid="cp-campaign-list">
            {campaigns.map((c) => (
              <div className="cp-clist-card" key={c.id} onClick={() => navigate(`/espace-client/campagnes/${c.id}`)} data-testid={`cp-campaign-${c.id}`}>
                <div className="cp-clist-body">
                  <p className="cp-clist-name">{c.name}</p>
                  <p className="cp-clist-meta">{frDate(c.start_date)} – {frDate(c.end_date)}{c.advertiser_label ? ` · ${c.advertiser_label}` : ""}</p>
                </div>
                <span className="cp-pill now">{c.status_label || c.status || "—"}</span>
                <span className="cp-chevron"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 6l6 6-6 6"/></svg></span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
